import { z } from 'zod';

/**
 * VIN (Vehicle Identification Number) validation schema
 * - Must be exactly 17 characters
 * - Cannot contain I, O, or Q
 * - Must contain only alphanumeric characters
 * - Automatically normalizes to uppercase and trims whitespace
 */
const vinSchema = z
    .string()
    .min(1, 'VIN is required')
    .refine((val) => {
    const normalized = val.trim().toUpperCase();
    return normalized.length === 17;
}, { message: 'VIN must be exactly 17 characters' })
    .refine((val) => {
    const normalized = val.trim().toUpperCase();
    return /^[A-HJ-NPR-Z0-9]{17}$/.test(normalized);
}, {
    message: 'VIN must contain only letters (A-Z, except I, O, Q) and numbers',
})
    .transform((val) => val.trim().toUpperCase());
/**
 * Assign VIN form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(assignVinFormSchema)
 */
const assignVinFormSchema = z.object({
    vin: vinSchema,
});

export { assignVinFormSchema, vinSchema };
//# sourceMappingURL=vinValidation.js.map
